// extracted by mini-css-extract-plugin
export default {"productGrid":"_2-z","centerLink":"a3-z","productSection":"b3-z","item":"c3-z","ctaButton":"d3-z"};